import React, { useEffect } from "react";

import FacebookIcon from "public/icons/Google.svg";
import ErrorIcon from "public/icons/error_icon.svg";

import { Button } from "@/components/form/Button/Button";
import { SvgIcon } from "@/components/ui/svg-icon/SvgIcon";
import { WithErrorBoundary } from "@/lib/error-boundary/WithErrorBoundary";

import { useGoogleInit } from "./useGoogleInit";

const GoogleButton: React.FC = () => {
  const { renderScripts, bindGoogleButton } = useGoogleInit();
  const buttonRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    bindGoogleButton(buttonRef.current);
  }, [bindGoogleButton]);

  return (
    <>
      <Button
        aria-label="Sign in with Google Button"
        variant="text"
        className="w-8 h-8 shadow"
      >
        <SvgIcon width={22} hanging={22}>
          <FacebookIcon />
        </SvgIcon>
        <div ref={buttonRef} className="absolute inset-0 opacity-0">
          {renderScripts()}
        </div>
      </Button>
    </>
  );
};

const Fallback: React.FC = () => {
  return (
    <Button variant="text" className="w-8 h-8 shadow">
      <SvgIcon>
        <ErrorIcon />
      </SvgIcon>
    </Button>
  );
};

export const GoogleRegistrationButton = WithErrorBoundary(<GoogleButton />, {
  fallback: <Fallback />,
});
